import { useParams } from "react-router-dom";
import React, { useState, useEffect, useRef, forwardRef } from 'react';
import { Sidebar } from '../dashboard_component';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import QRCode from "react-qr-code";
import {
  get_question_manual_grade, UpdateScoreUrl
} from "../serverurl";
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { ajaxconfig } from '../ajaxconfig';

const TestData = () => {
  // State and hooks
  const [db_cbt_question, set_db_cbt_question] = useState([]);
  const [cbt_data, set_cbt_data] = useState({});
  const [question_count, set_question_count] = useState(0);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [activeQuestion, setActiveQuestion] = useState(null);
  const navigate = useNavigate();

  // URL Params
  const url_param = new URLSearchParams(window.location.search);
  const { cbt_pass_code } = useParams();
  const { cbt_test_id } = useParams();
  const { cbt_permit_code } = useParams();
  const cbtbarcode = `https://app.bthost.com/qr_verification?cbt_pass_code=${cbt_pass_code}`;
  const config = ajaxconfig();

  // Fetch test data
  const GetQuestion = `${get_question_manual_grade}/${cbt_pass_code}/${cbt_permit_code}/${cbt_test_id}`;
  
  const refresh = () => {
    setIsLoading(true);
    axios.get(GetQuestion, config)
      .then((response) => {
        console.log(response);
        toast.success(response.data.message);
        if (response.data.data) {
          set_db_cbt_question(response.data.data);
          set_question_count(response.data.data.length);
          set_cbt_data(response.data.cbt_data || {});
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error)
        toast.error(error.message || "Failed to load questions");
        setIsLoading(false);
      });
  };

  useEffect(() => {
    refresh();
  }, [cbt_pass_code, cbt_permit_code]);

  const handleToggle = () => setIsCollapsed(!isCollapsed);

  // Calculate total score
  const totalScore = db_cbt_question.reduce((acc, question) => {
    return acc + (parseInt(question.manual_score) || parseInt(question.score_data?.point_accumulated) || 0);
  }, 0);

  return (
    <div className="flex min-h-screen bg-gradient-to-br from-slate-50 to-blue-50/20">
      <Sidebar isCollapsed={isCollapsed} onToggle={handleToggle} />
      
      <div 
        className={`flex-1 transition-all duration-300 pt-16 lg:pt-8 ${
          isCollapsed ? 'lg:ml-20' : 'lg:ml-64'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header Section */}
          <div className="mb-8">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
              <div>
                <h1 className="text-3xl font-bold text-gray-900 mb-2">Test Results Analysis</h1>
                <div className="flex items-center gap-3 flex-wrap">
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                    </svg>
                    {cbt_pass_code}
                  </span>
                  <span className="text-gray-600">•</span>
                  <span className="text-gray-600 font-medium">Test ID: {cbt_test_id}</span>
                  <span className="text-gray-600">•</span>
                  <span className="text-gray-600">{question_count} Questions</span>
                </div>
              </div>
              
              <button
                onClick={refresh}
                className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-xl text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-all duration-200 shadow-sm"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clipRule="evenodd" />
                </svg>
                Refresh Data
              </button>
            </div>

            {/* Stats Overview */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
              <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Total Questions</p>
                    <p className="text-2xl font-bold text-gray-900 mt-1">{question_count}</p>
                  </div>
                  <div className="p-3 bg-blue-100 rounded-xl">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Total Score</p>
                    <p className="text-2xl font-bold text-gray-900 mt-1">{totalScore}</p>
                  </div>
                  <div className="p-3 bg-green-100 rounded-xl">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Default Score</p>
                    <p className="text-2xl font-bold text-gray-900 mt-1">{cbt_data.default_score || 'N/A'}</p>
                  </div>
                  <div className="p-3 bg-purple-100 rounded-xl">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Test Status</p>
                    <p className="text-2xl font-bold text-gray-900 mt-1">
                      {isLoading ? "Loading..." : "Ready"}
                    </p>
                  </div>
                  <div className="p-3 bg-orange-100 rounded-xl">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-orange-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
            {/* Sidebar - Question Navigation */}
            <div className="lg:col-span-1">
              <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 sticky top-6">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-semibold text-gray-900">Questions</h3>
                  <span className="bg-gray-100 text-gray-600 text-sm px-2 py-1 rounded-full">
                    {db_cbt_question.length}
                  </span>
                </div>
                
                {/* QR Code */}
                <div className="mb-6 p-4 bg-gray-50 rounded-xl border border-gray-200">
                  <div className="flex justify-center mb-3">
                    <div className="bg-white p-3 rounded-lg border border-gray-300">
                      <QRCode 
                        size={120} 
                        className="w-full h-auto"
                        value={cbtbarcode} 
                      />
                    </div>
                  </div>
                  <p className="text-center text-xs text-gray-500 font-medium">Test QR Code</p>
                </div>

                {/* Question Navigation */}
                <div className="space-y-2 max-h-96 overflow-y-auto">
                  {db_cbt_question.map((question, index) => (
                    <button
                      key={question.cbt_question_id}
                      onClick={() => {
                        setActiveQuestion(index);
                        document.getElementById(`Question_${index + 1}`)?.scrollIntoView({ 
                          behavior: 'smooth',
                          block: 'start'
                        });
                      }}
                      className={`w-full text-left p-3 rounded-xl border transition-all duration-200 ${
                        activeQuestion === index
                          ? 'bg-blue-50 border-blue-200 text-blue-700'
                          : 'bg-gray-50 border-gray-200 text-gray-700 hover:bg-gray-100'
                      }`}
                    >
                      <div className="flex items-center justify-between">
                        <span className="font-medium">Question {index + 1}</span>
                        <span className={`text-sm px-2 py-1 rounded-full ${
                          question.manual_score 
                            ? 'bg-green-100 text-green-800'
                            : 'bg-gray-200 text-gray-600'
                        }`}>
                          {question.manual_score || question.score_data?.point_accumulated || 0}
                        </span>
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* Questions List */}
            <div className="lg:col-span-3">
              <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
                <div className="border-b border-gray-200 bg-gradient-to-r from-gray-50 to-white px-6 py-4">
                  <h2 className="text-xl font-semibold text-gray-900">Questions & Answers</h2>
                  <p className="text-gray-600 text-sm mt-1">
                    Review student responses and assign custom grades
                  </p>
                </div>
                
                <div className="p-6">
                  {isLoading ? (
                    <div className="text-center py-12">
                      <div className="inline-flex items-center justify-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                      </div>
                      <p className="mt-4 text-gray-600 font-medium">Loading questions, please wait...</p>
                      <p className="text-sm text-gray-500 mt-1">Fetching test data from server</p>
                    </div>
                  ) : db_cbt_question?.length > 0 ? (
                    <div className="space-y-6">
                      {db_cbt_question.map((data, index) => (
                        <Obj
                          key={data.cbt_question_id}
                          cbt_pass_code={cbt_pass_code}
                          cbt_test_id={cbt_test_id}
                          qdata={data}
                          cbt_question_id={data.cbt_question_id}
                          user_option={data.user_option}
                          refresh={refresh}
                          indexof={index}
                          isActive={activeQuestion === index}
                        />
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-12">
                      <div className="w-20 h-20 mx-auto mb-4 text-gray-400">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                      <h3 className="text-lg font-medium text-gray-900 mb-2">No Questions Available</h3>
                      <p className="text-gray-500 max-w-sm mx-auto">
                        No questions found for test {cbt_test_id} with passcode {cbt_pass_code}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer 
        position="top-right" 
        autoClose={3000}
        toastClassName="rounded-xl shadow-lg"
        progressClassName="bg-gradient-to-r from-blue-500 to-purple-500"
      />
    </div>
  );
};

const Obj = forwardRef(({ 
  cbt_pass_code, 
  cbt_test_id, 
  qdata, 
  cbt_question_id, 
  user_option, 
  refresh, 
  indexof,
  isActive 
}, ref) => {
  const [customScore, setCustomScore] = useState(qdata.manual_score || '');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSavingScore, setIsSavingScore] = useState(false);
  const config = ajaxconfig();

  const submitCustomScore = async (e) => {
    e.preventDefault();
    setIsSavingScore(true);

    console.log({ 
      cbt_question_id, 
      customScore,
      cbt_pass_code,
      cbt_test_id,
      // user_id: qdata.answer_data.user_id
    });
    
    try {
      const response = await axios.post(UpdateScoreUrl, { 
        cbt_question_id, 
        customScore,
        cbt_pass_code,
        cbt_test_id,
        // user_id: qdata.answer_data.user_id
      }, config);
      
      console.log(response);
      toast.success(`✅ Score updated to ${customScore} for question ${indexof + 1}`);
      setIsSavingScore(false);
      
      // Refresh data after update
      // refresh();
      
    } catch (error) {
      console.log(error);
      toast.error("❌ Failed to update score");
      setIsSavingScore(false);
    }
  };

  const getScoreColor = (score) => {
    const numScore = parseInt(score) || 0;
    if (numScore >= 8) return "bg-green-100 text-green-800 border-green-200";
    if (numScore >= 5) return "bg-blue-100 text-blue-800 border-blue-200";
    if (numScore >= 3) return "bg-yellow-100 text-yellow-800 border-yellow-200";
    return "bg-red-100 text-red-800 border-red-200";
  };

  return (
    <div 
      key={qdata.id} 
      className={`border rounded-2xl overflow-hidden transition-all duration-300 ${
        isActive 
          ? 'border-blue-300 shadow-md bg-blue-50/30' 
          : 'border-gray-200 shadow-sm hover:shadow-md hover:border-gray-300'
      }`}
      id={`Question_${indexof + 1}`}
    >
      {/* Question Header */}
      <div className="bg-gradient-to-r from-gray-50 to-white p-6 border-b border-gray-200">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <div>
            <h3 className="text-xl font-semibold text-gray-900">
              Question {indexof + 1}
            </h3>
            <div className="flex items-center gap-3 mt-2">
              <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium border ${getScoreColor(qdata.manual_score || qdata.score_data?.point_accumulated)}`}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                Score: {qdata.manual_score || qdata.score_data?.point_accumulated || 0}
              </span>
              {qdata.manual_score && (
                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                  Manually Graded
                </span>
              )}
            </div>
          </div>
          
          <div className="text-sm text-gray-500 bg-white px-3 py-1 rounded-lg border border-gray-200">
            ID: {cbt_question_id}
          </div>
        </div>
      </div>
      
      {/* Question Content */}
      <div className="p-6 space-y-6">
        {/* Question Text */}
        <div>
          <h4 className="font-semibold text-gray-700 mb-3 text-lg">Question:</h4>
          <div className="prose prose-lg max-w-none bg-gray-50 rounded-xl p-4 border border-gray-200">
            <div dangerouslySetInnerHTML={{ __html: qdata.question.cbt_question }} />
          </div>
        </div>
        
        {/* Student Answer */}
        <div>
          <h4 className="font-semibold text-gray-700 mb-3 text-lg flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 005 10a6 6 0 0112 0c0 .-.1.389-.029.777A5 5 0 0010 11z" clipRule="evenodd" />
            </svg>
            Student's Answer:
          </h4>
          <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
            {qdata.answer_data ? (
              <div className="prose prose-blue max-w-none" dangerouslySetInnerHTML={{ __html: qdata.answer_data.options }} />
            ) : (
              <div className="text-center py-4 text-gray-500 italic">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mx-auto mb-2 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                </svg>
                No answer provided by student
              </div>
            )}
          </div>
        </div>
        
        {/* Custom Grading Section */}
        <div className="border-t border-gray-200 pt-6">
          <h4 className="font-semibold text-gray-700 mb-4 text-lg flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-purple-600" viewBox="0 0 20 20" fill="currentColor">
              <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
            </svg>
            Custom Grading
          </h4>
          
          <form onSubmit={submitCustomScore} className="bg-gray-50 rounded-xl p-4 border border-gray-200">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-end">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Adjust Score
                </label>
                <div className="flex items-center gap-3">
                  <input
                    type="number"
                    min="0"
                    step="1"
                    value={customScore}
                    onChange={(e) => setCustomScore(e.target.value)}
                    className="w-32 p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                    placeholder="Enter score"
                  />
                  <span className="text-gray-500 font-medium">points</span>
                </div>
                <p className="mt-2 text-sm text-gray-500">
                  Enter a minimum value of 0. Current auto-score: <span className="font-medium">{qdata.score_data?.point_accumulated || 0}</span>
                </p>
              </div>
              
              <div className="flex gap-3">
                <button
                  type="submit"
                  disabled={isSavingScore}
                  className={`flex-1 flex items-center justify-center gap-2 px-6 py-3 rounded-xl font-medium transition-all duration-200 ${
                    isSavingScore 
                      ? 'bg-blue-400 cursor-not-allowed text-white' 
                      : 'bg-blue-600 hover:bg-blue-700 text-white shadow-sm hover:shadow-md'
                  }`}
                >
                  {isSavingScore ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
                      Updating...
                    </>
                  ) : (
                    <>
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      Update Score
                    </>
                  )}
                </button>
                
                <button
                  type="button"
                  onClick={() => setCustomScore(qdata.score_data?.point_accumulated || '')}
                  className="px-4 py-3 border border-gray-300 rounded-xl text-gray-700 bg-white hover:bg-gray-50 transition-all duration-200"
                >
                  Reset
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
});

export { TestData };